/* eslint-disable quote-props */
import { config } from 'api';

const domainDataUrl = 'https://cookies-data.onetrust.io/bannersdk/domaindata';
const domainDataLocation = 'cdn-ukwest.onetrust.com';
const policyUrl = '/cookies/policy';
const removeCookiesUrl = '/cookies/removeCookies';

export function getCookiesData(onSuccess) {
  return (dispatch, getState, { network }) => {
    const state = getState();

    const oneTrustDomainId = state.user.betaFeatures.includes('USE_ONE_TRUST_DOMAIN_ID_FROM_DB_ON_RAVEN')
      && state.properties.oneTrustDomainId
      || config.cookieConsent.domainId;

    const categorization = {};
    network.get(domainDataUrl,
      {
        headers: {
          'lang': 'en',
          'domain': oneTrustDomainId,
          'location': domainDataLocation,
        },
      }, true)
      .then(data => {
        data.culture.DomainData.Groups.forEach(group => {
          const { CustomGroupId, FirstPartyCookies } = group;
          if (CustomGroupId && FirstPartyCookies) {
            categorization[CustomGroupId] = FirstPartyCookies.map(cookie => cookie.Name, []);
          }
        });
        onSuccess(categorization);
      })
      .catch(error => {
        console.error('Could not load cookies categorization. ', error);// eslint-disable-line no-console
      });
  };
}

export function saveCookies(cookiesList) {
  const { apiBasePath } = config;

  return (dispatch, getState, { network }) => {
    network.post(apiBasePath + policyUrl, {
      body: JSON.stringify(cookiesList),
    }).then(() => {
      network.post(apiBasePath + removeCookiesUrl);
    });
  };
}
